// Convert cm to mm and mm to cm
export const cmToMm = (cm: number) => cm * 10;
export const mmToCm = (mm: number) => mm / 10;

// Calculate the normalized orientation value for a plane coordinate.
export const calculateNormalizedOrientationValue = (
    planeCoordinates: number
): string => {
    return (-Math.round(planeCoordinates * 10) / 100).toFixed(2);
};
